import React, { useContext, useEffect } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useLocationService from '../../../app/services/hooks/useLocationService';

interface Props {
    locationId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const LocationSwitchChange = ({ locationId, checkValue, callbackSuccess }: Props) => {
    const { hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { activeLocation } = useLocationService();

    useEffect(() => {
        setChecked(checkValue);
    }, [checkValue]);

    const active = (value: boolean) => {
        setChecked(value);
        activeLocation(locationId, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={locationId} callback={active} />;
};

export default LocationSwitchChange;
